import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountInfo } from '@context/AccountInfoContext/AccountInfoContext.Provider'
import { useSessionEntity } from '@context/EntityContext'
import { useSupportContacts } from '@context/SupportContactsContext'

import { isTickmillASType, isTickmillSCType } from '@utils/companyName.utils'

export const useTradingAccountsMessage = (): string | undefined => {
  const { accountInfoLimits } = useAccountInfo()

  const entity = useSessionEntity()
  const { t } = useTranslation()

  const { supportEmail } = useSupportContacts()

  return useMemo(() => {
    if (!accountInfoLimits) {
      return
    }
    if (accountInfoLimits.hasReachedMaxTradingAccounts) {
      return t('Trading Account.You have reached the maximum amount of live trading accounts', {
        maxTotalLimit: accountInfoLimits.maxTotalLimit,
        email: supportEmail,
      })
    } else {
      if ((isTickmillASType(entity) || isTickmillSCType(entity)) && accountInfoLimits.tmt > 0) {
        return t(
          'Trading Account.You can hold a maximum of x Live Trading Accounts for MT4 platform, Tickmill Trader/TradingView platform',
          {
            maxMT4Accounts: accountInfoLimits.mt4,
            maxMT5Accounts: accountInfoLimits.mt5,
            maxTMTAccounts: accountInfoLimits.tmt,
          }
        )
      } else {
        return t('Trading Account.You can hold a maximum of max Live Trading Accounts for', {
          maxMT4Accounts: accountInfoLimits.mt4,
          maxMT5Accounts: accountInfoLimits.mt5,
        })
      }
    }
  }, [accountInfoLimits, t, supportEmail, entity])
}
